export enum UsageDataRouteName {
  Dashboard = 'usage-data-dashboard',
}
